import { IsoDayOfWeek } from "app/shared/model/EditProductOffering";

const DAY_NAME_TO_VALUE: Record<string, IsoDayOfWeek> = {
  monday: IsoDayOfWeek.Monday,
  tuesday: IsoDayOfWeek.Tuesday,
  wednesday: IsoDayOfWeek.Wednesday,
  thursday: IsoDayOfWeek.Thursday,
  friday: IsoDayOfWeek.Friday,
  saturday: IsoDayOfWeek.Saturday,
  sunday: IsoDayOfWeek.Sunday,
};

function mapNumericDayToIso(n: number): IsoDayOfWeek | null {
  if (n === 0) {
    return IsoDayOfWeek.Sunday;
  }
  if (n >= IsoDayOfWeek.Monday && n <= IsoDayOfWeek.Sunday) {
    return n as IsoDayOfWeek;
  }
  return null;
}

export function normalizeRecurranceStartDays(raw: unknown): IsoDayOfWeek[] {
  const arr = Array.isArray(raw) ? raw : [];
  const out: IsoDayOfWeek[] = [];

  for (const item of arr) {
    if (item == null) continue;

    if (typeof item === "number" && Number.isFinite(item)) {
      const mapped = mapNumericDayToIso(Math.trunc(item));
      if (mapped != null) {
        out.push(mapped);
      }
      continue;
    }

    if (typeof item === "string") {
      const trimmed = item.trim();
      if (!trimmed) continue;
      const asNum = Number(trimmed);
      if (Number.isFinite(asNum)) {
        const mapped = mapNumericDayToIso(Math.trunc(asNum));
        if (mapped != null) {
          out.push(mapped);
        }
        continue;
      }
      const named = DAY_NAME_TO_VALUE[trimmed.toLowerCase()];
      if (named != null) {
        out.push(named);
      }
    }
  }

  return [...new Set(out)].filter((d) => d !== IsoDayOfWeek.None);
}

export function formatRecurranceStartDaysLabel(days: unknown): string {
  const normalized = normalizeRecurranceStartDays(days);
  if (!normalized.length) return "";
  return normalized
    .map((sd) => IsoDayOfWeek[sd])
    .filter((name) => name && name !== "None")
    .join(", ");
}